import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 2000);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem('cookie-consent', 'dismissed');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-consent-banner"
      className={`fixed bottom-20 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-40 transition-all duration-500 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'
      }`}
    >
      <div className="bg-[#0A0A0A] border border-white/10 rounded-2xl p-5 shadow-2xl shadow-black/30">
        <div className="flex items-start gap-3">
          <div className="flex-1">
            <p className="text-sm text-slate-300 leading-relaxed">
              This site uses cookies to improve your experience. By continuing to browse, you agree to our use of cookies.
            </p>
          </div>
          <button
            data-testid="cookie-dismiss-btn"
            onClick={dismiss}
            className="text-slate-500 hover:text-white transition-colors flex-shrink-0 mt-0.5"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex gap-3 mt-4">
          <button
            data-testid="cookie-accept-btn"
            onClick={accept}
            className="px-5 py-2 bg-[#00E5FF] text-[#0A0A0A] text-sm font-semibold rounded-full hover:bg-white transition-colors"
          >
            Accept
          </button>
          <button
            data-testid="cookie-decline-btn"
            onClick={dismiss}
            className="px-5 py-2 bg-white/5 text-slate-400 text-sm font-medium rounded-full hover:text-white hover:bg-white/10 transition-colors border border-white/10"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
}
